export default {
  // 页面标题
  title: '优惠码',
  
  // 表单相关
  form: {
    title: '兑换优惠码',
    codePlaceholder: '请输入优惠码',
    codeRequired: '请输入优惠码',
    submitButton: '兑换',
  },
  
  // 成功消息
  success: {
    title: '兑换成功！',
  },
  
  // 优惠券列表
  couponList: {
    redemptionTime: '兑换时间：',
  },
  
  // 状态
  status: {
    active: '有效',
    inactive: '无效',
    pending: '待处理',
    expired: '已过期',
    used: '已使用',
    redeemed: '已兑换',
  },
};
